import PropTypes from "prop-types"
import { List, ListItemButton, ListItemText } from "@mui/material"
import { map, size } from "lodash"
import { SubcategoryShape } from "./helpers/prop-types"
import Metric from "./metric-item"
import CheckboxElement from "./checkbox"
import ExpandIcon from "./expandIcon"

export default function MetricsSubcategory({
  subcategory,
  disableOptions,
  toggleSection,
  toggleSelectedMetricColumn,
  includeMetricTypes,
  metricsSearchValue,
  getIsSectionOpen,
}) {
  const { type, id, items, selected, selectedItemsCount, itemsCount, singleFactor, label } = subcategory || {}
  const showCategoryItems = size(items) > 0
  const shouldShowCategory = showCategoryItems || singleFactor

  if (!shouldShowCategory) {
    return null
  }

  const isDisabled = !selected && !showCategoryItems && disableOptions
  const sectionKey = `${type}.${id}`
  const isSectionOpen = getIsSectionOpen(sectionKey)

  const itemCountLabel = metricsSearchValue
    ? ` (${size(items)} found)`
    : ` (${selectedItemsCount}/${itemsCount})`

  function handleClick() {
    const handler = showCategoryItems ? toggleSection : toggleSelectedMetricColumn
    handler(type, id)
  }

  return <List disablePadding className="metrics-subcategory">
    <ListItemButton
      disabled={isDisabled}
      classes={{ root: "list-item" }}
      onClick={handleClick}
    >
      <CheckboxElement
        isHidden={showCategoryItems}
        isChecked={selected}
        isDisabled={isDisabled}
        className="metrics-checkbox"
      />
      <ListItemText>
        {label}
        {!singleFactor && <span className="items-count">{itemCountLabel}</span>}
      </ListItemText>
      <ExpandIcon
        isOpen={isSectionOpen}
        isHidden={!showCategoryItems}
      />
    </ListItemButton>

    {showCategoryItems && isSectionOpen && <List className="searchable-list" disablePadding>
      {map(items, item => <Metric
        key={`${type}.${item.id}`}
        subcategoryType={subcategory.type}
        item={item}
        toggleSection={toggleSection}
        toggleSelectedMetricColumn={toggleSelectedMetricColumn}
        disableOptions={disableOptions}
        includeMetricTypes={includeMetricTypes}
        metricsSearchValue={metricsSearchValue}
        getIsSectionOpen={getIsSectionOpen}
      />)}
    </List>}
  </List>
}

MetricsSubcategory.propTypes = {
  subcategory: SubcategoryShape.isRequired,
  toggleSection: PropTypes.func.isRequired,
  toggleSelectedMetricColumn: PropTypes.func.isRequired,
  disableOptions: PropTypes.bool.isRequired,
  includeMetricTypes: PropTypes.bool,
  metricsSearchValue: PropTypes.string.isRequired,
  getIsSectionOpen: PropTypes.func.isRequired,
}
